import { render, staticRenderFns } from "./Downloadlatest.vue?vue&type=template&id=320317e3&scoped=true"
import script from "./Downloadlatest.vue?vue&type=script&lang=js"
export * from "./Downloadlatest.vue?vue&type=script&lang=js"
import style0 from "./Downloadlatest.vue?vue&type=style&index=0&id=320317e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f1c606d12331ca9397f00d9371f47138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320317e3",
  null
  
)

export default component.exports